<template>

    <div class="account-container m-xl-0">

        <router-link class="return-to-bookings" v-bind:to="{name : 'account_stay_bookings'}">
            Back to all bookings
        </router-link>

        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>
        <div v-if="!isLoading && booking != null">
            <div class="row">
                <div class="col-xl-12">
                    <h2>{{formatStayDate(arrivalDate)}}: {{booking.length}} {{booking.length == 1 ? 'Room' : 'Rooms'}}</h2>
                </div>
                <div class="col-xl-12 mb-4 ">
                    <div class="row">
                        <div class="col-xl-12">


                            <a class="lnk-print mr-2"
                               v-on:click="printWindow();">Print Confirmation</a>

                        </div>
                        <div class="col-xl-12">


                            <a class="lnk-email ml-2"
                               v-on:click="resendConfirmation()">Resend confirmation</a>

                        </div>

                    </div>
                </div>
            </div>


            <div v-if="sendEmail" class="row justify-content-start ">
                <div class="col-xl-24  mb-5">


                    <Form @submit="onSendEmail" :validation-schema="schema">

                        <div class=" p-5 bg-white has-shadow ">
                            <h3>Resend Confirmation</h3>
                            <p>Enter an email address below and we'll send a copy of your confirmation.</p>

                            <div v-if="!isEmailLoading">
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">

                                        <Field name="emailAddress" class="form-control" placeholder="Email address"></Field>

                                    </div>
                                    <button class="btn btn--gold col-12 col-xl-8" type="submit">Send</button>
                                </div>
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">
                                        <ErrorMessage name="emailAddress" class="error-message" />


                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">

                                        <div class="d-flex justify-content-center">
                                            <loader></loader>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>


                    </Form>
                </div>
            </div>



            <div class="row mb-4">


                <div class="col-24" v-bind:class="{'col-xl-12' : booking.items.length > 1}"
                     v-for="(room, index) in booking.items">
                    <account-stay-summary-panel v-bind:room="room"></account-stay-summary-panel>
                </div>


            </div>


            <div>

                <div>
                    <div v-if="!isCancelled && isFutureBooking">
                        <account-stay-upsell v-bind:booking="booking.items"></account-stay-upsell>
                    </div>

                    <div class="view-booking-block">
                        <div v-if="!isCancelled && isFutureBooking"
                             class="row mb-4">
                            <div class="col-12">
                                <div class="amend-cancel-block">
                                    <h3>Want to make a change?</h3>
                                    <p>
                                        You can easily amend your booking until 14 days prior to your stay (or until the day before arrival if you're on a flexible rate).
                                    </p>
                                    <ul>
                                        <li>Need new dates?</li>
                                        <li>Change the number of guests?</li>
                                        <li>Want to change or upgrade your room type?</li>
                                    </ul>

                                    <div class="btn-container btn-container--start mt-3">
                                        <button class="btn btn--slate-blue " type="button" v-on:click="onAmend()">
                                            Amend Booking
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 ">
                                <div class="amend-cancel-block">
                                    <h3>Need to Cancel?</h3>
                                    <p>
                                        If you've booked a flexible rate, your stay can be cancelled until 3pm the day prior to your arrival.
                                    </p>

                                    <button class="btn btn--slate-blue mt-3" type="button" v-on:click="onCancel()">
                                        Cancel Booking
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-14">
                                <h3>Booking Terms &amp; Conditions</h3>

                                <div class="row">

                                    <div class="col-24 mb-3"
                                         v-for="(room, index) in booking.items">


                                        <h4 v-if="booking.length > 1">Room {{room.Leg}}</h4>

                                        <div>
                                            <strong>Cancellation Policy: </strong>
                                            <p v-html="room.CancellationPolicy"></p>
                                        </div>



                                        <div>
                                            <strong>Tax Information: </strong>
                                            <p v-html="room.TaxInformation"></p>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>




    <standard-modal v-if="isCancelling" v-on:close="isCancelling = false">

        <template v-slot:header>
            <h2 class="mb-5">Need to cancel?</h2>
        </template>
        <template v-slot:body>


            <div class="col-24 ">
                <div class="row col-mb-3 bg-white mb-3 g-0"
                     v-for="(booking, index) in populatedBooking">
                    <div class="col-xl-7">
                        <div class="stay-booking-gallery">
                            <single-image-gallery v-bind:images="booking.content.Images"></single-image-gallery>
                        </div>
                    </div>
                    <div class="col-xl-11 p-4">
                        <h2>Room {{booking.room.Leg}}</h2>


                        <div class="row">

                            <div class="col-24 mb-2 d-flex justify-content-between"><span class="stay-info-label">Room Type:</span>{{booking.content.DisplayName}}</div>
                            <div v-if="booking.room.GuestQuota.Dogs" class="col-xl-12 mb-2 d-flex justify-content-between"><span class="stay-info-label">Dogs:</span>{{booking.room.GuestQuota.Dogs}}  {{booking.room.GuestQuota.Dogs == 1 ? 'dog' : 'dogs'}}</div>
                            <div class="col-24 mb-2 d-flex justify-content-between"><span class="stay-info-label">Guests:</span>{{formatGuests(booking.room.GuestQuota)}}</div>

                            <div class="col-24 mb-2 d-flex justify-content-between"><span class="stay-info-label">Rate:</span>{{getRateType(booking.room.RateCode)}}</div>


                            <div class="col-24 mb-2">
                                <div class="row">
                                    <div class="col-8">
                                        <span class="stay-info-label">Names:</span>
                                    </div>
                                    <div class="col-16 d-flex justify-content-end">
                                        <ul class="guest-names">
                                            <li v-bind:key="index"
                                                v-for="(guest, index) in booking.room.GuestNames">
                                                {{guest}}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                    <div class="col-xl-6 p-4  d-flex justify-content-end flex-column">

                        <div v-if="booking.room.IsCancelled">
                            <info-box v-bind:type="'alert'">
                                <template v-slot:body>
                                    <span class="heading">
                                        This booking is cancelled.
                                    </span>

                                </template>
                            </info-box>
                        </div>
                        <div v-else-if="canCancel(booking.room)" class="p-4 ">
                            <div class="mb-3">
                                <strong>Cancel until:</strong><br /> {{formatCancelTime(booking.room.CancellationDateTime)}}
                            </div>

                            <button class="btn btn--slate-blue btn--block"
                                    v-on:click="onCancelRoom(booking)">
                                Cancel
                            </button>
                        </div>

                        <div v-else>
                            <info-box v-bind:type="'alert'">
                                <template v-slot:body>
                                    <span class="heading">
                                        This booking cannot be cancelled online, please contact the hotel to cancel your booking.
                                    </span>

                                </template>
                            </info-box>


                        </div>
                    </div>

                </div>




                <div class="row" v-if="canCancelAll()">
                    <div class="offset-xl-19 col-xl-5">

                        <button class="btn btn--slate-blue btn--block"
                                v-on:click="onCancelAll()">
                            Cancel All
                        </button>


                    </div>

                </div>
            </div>



        </template>
    </standard-modal>

    <standard-modal v-if="isAmending" v-on:close="isAmending = false">

        <template v-slot:header>
            <h2 class="mb-5">Want to make a change?</h2>
        </template>
        <template v-slot:body>

            <div class="row">
                <div class="col-24 ">
                    <div class="row col-mb-3 bg-white mb-3 g-0"
                         v-for="(booking, index) in populatedBooking">
                        <div class="col-xl-7">
                            <div class="stay-booking-gallery">
                                <single-image-gallery v-bind:images="booking.content.Images"></single-image-gallery>
                            </div>
                        </div>
                        <div class="col-xl-11 p-4">
                            <h2>Room {{booking.room.Leg}}</h2>


                            <div class="row">

                                <div class="col-24 mb-2 d-flex justify-content-between"><span class="stay-info-label">Room Type:</span>{{booking.content.DisplayName}}</div>
                                <div v-if="booking.room.GuestQuota.Dogs" class="col-xl-12 mb-2 d-flex justify-content-between"><span class="stay-info-label">Dogs:</span>{{booking.room.GuestQuota.Dogs}}  {{booking.room.GuestQuota.Dogs == 1 ? 'dog' : 'dogs'}}</div>
                                <div class="col-24 mb-2 d-flex justify-content-between"><span class="stay-info-label">Guests:</span>{{formatGuests(booking.room.GuestQuota)}}</div>

                                <div class="col-24 mb-2 d-flex justify-content-between"><span class="stay-info-label">Rate:</span>{{getRateType(booking.room.RateCode)}}</div>


                                <div class="col-24 mb-2">
                                    <div class="row">
                                        <div class="col-8">
                                            <span class="stay-info-label">Names:</span>
                                        </div>
                                        <div class="col-16 d-flex justify-content-end">
                                            <ul class="guest-names">
                                                <li v-bind:key="index"
                                                    v-for="(guest, index) in booking.room.GuestNames">
                                                    {{guest}}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>



                        </div>
                        <div class="col-xl-6 p-4  d-flex justify-content-end flex-column">
                            <div v-if="booking.room.IsCancelled">
                                <info-box v-bind:type="'alert'">
                                    <template v-slot:body>
                                        <span class="heading">
                                            This booking is cancelled.
                                        </span>

                                    </template>
                                </info-box>
                            </div>

                            <div v-else-if="canAmend(booking.room)" class="p-4 ">
                                <div class="mb-3">
                                    <div class="mb-3">
                                        <strong>Amend until:</strong><br /> {{formatCancelTime(booking.room.CancellationDateTime)}}
                                    </div>
                                    <button class="btn btn--slate-blue btn--block"
                                            v-on:click="onAmendRoom(booking.room)">
                                        Amend
                                    </button>
                                </div>

                            </div>
                            <div v-else>
                                <info-box v-bind:type="'alert'">
                                    <template v-slot:body>
                                        <span class="heading" v-if="hasVoucher">

                                            Your booking cannot be amended online. Please contact us to make any changes.

                                        </span>
                                        <span v-else class="heading">
                                            Your booking cannot be amended.
                                        </span>

                                    </template>
                                </info-box>


                            </div>
                        </div>

                    </div>
                </div>




            </div>



        </template>
    </standard-modal>

</template>

<script>
    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";

    import AccountStaySummaryPanel from '../components/AccountStaySummaryPanel.vue';
    import AccountStayUpsell from '../components/AccountStayUpsell.vue';
    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';

    import InfoBox from '@/shared/components/InfoBox.vue';
    import Loader from '@/shared/components/Loader.vue';
    import StandardModal from '@/shared/components/StandardModal.vue';

    import { accountStore } from '../store/index';

    import stayapi from '@/shared/api/stay';

    export default {
        name: 'AccountStayBookings',

        mounted() {
            var so = this;
            so.isLoading = true;

            if (this.configuration == null) {
                accountStore.dispatch("getConfiguration");
            }


            so.getBooking();

        },
        components: {
            AccountStaySummaryPanel,
            AccountStayUpsell,
            Loader,
            StandardModal,
            SingleImageGallery,
            InfoBox,
            Field,
            Form,
            ErrorMessage,
        },
        computed: {
            isCancelled() {


                var result = true;

                if (this.booking.items !== undefined) {

                    for (let i = 0; i < this.booking.items.length; i++) {
                        let b = this.booking.items[i];
                        result = result && b.IsCancelled;
                    }
                }
                return result;
            },
            configuration() {
                return accountStore.getters.accountConfiguration;
            },
            confirmationNumber() {
                return this.$route.params.id;
            },
            arrivalDate() {
                if (this.booking.items != null) {
                    return this.booking.items[0].DateRange.StartDate;
                }
                return null;
            },
            isFutureBooking() {
                if (this.arrivalDate != null) {
                    let momentArrival = moment(this.arrivalDate);
                    if (momentArrival > moment()) {
                        return true;
                    }
                }

                return false;;
            },
            populatedBooking() {
                let result = [];

                if (this.configuration != undefined && this.configuration != null) {
                    if (this.booking.items != undefined && this.booking.items != null) {
                        for (let ri = 0; ri < this.booking.items.length; ri++) {
                            let room = this.booking.items[ri];
                            let content = this.configuration.RoomTypes.find(item => item.PMSCode == room.RoomCode);
                            result.push({
                                room: room,
                                content: content
                            })

                        }
                    }
                }

                return result;
            },
            hasVoucher() {

                return this.booking.hasVoucher;
            }
        },
        data() {

            const schema = yup.object().shape({
                emailAddress: yup.string().required().email().label("Email address"),
            });


            return {
                schema,
                booking: null,
                isLoading: false,
                isEmailLoading: false,
                isCancelling: false,
                isAmending: false,
                sendEmail: false,
            }
        },
        methods: {
            onSendEmail(values) {
                this.isEmailLoading = true;

                let payload = {
                    confirmation: this.confirmationNumber,
                    emailAddress: values.emailAddress
                }


                let so = this;
                stayapi.sendEmail(payload, t => {
                    this.isEmailLoading = false;
                },
                    f => {
                        this.isEmailLoading = false;
                    });
            },
            getBooking() {
                let so = this;
                stayapi.getBooking(this.confirmationNumber, t => {

                    so.booking = t;
                    so.isLoading = false;
                });
            },
            cancelBooking(payload) {
                let so = this;
                stayapi.cancelBooking(payload, t => {
                    so.isLoading = true;
                    so.getBooking();
                    so.isCancelling = false;
                });
            },
            onAmend() {
                this.isAmending = true;
            },
            onAmendRoom(room) {
                let adults = room.GuestQuota.Adults;
                let children = room.GuestQuota.Children;
                let dogs = room.GuestQuota.Dogs
                let arrival = moment(room.DateRange.StartDate);
                let departure = moment(room.DateRange.EndDate);
                let days = departure.diff(arrival, 'days');

                window.location.href = '/booking/stay/#/stay/search/?amend=' + room.InternalIdentifier
                    + '&arrivalDate=' + arrival.format("YYYY-MM-DD")
                    + '&numberOfNights=' + days
                    + '&occupancy=[[' + adults + ',' + children + ',' + dogs+ ']]';
            },
            onCancel() {
                this.isCancelling = true;
            },
            onCancelRoom(item) {
                let so = this;
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "Room " + item.room.Leg + " will be cancelled.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#a10000',
                    cancelButtonColor: '#425261',

                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                }).then((result) => {
                    if (result.isConfirmed) {
                        let payload = {
                            confirmationNumber: so.confirmationNumber,
                            legs: [
                                item.room.Leg
                            ]
                        };

                        so.cancelBooking(payload);
                    }
                })

            },



            onCancelAll() {
                let so = this;
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "All rooms will be cancelled.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#a10000',
                    cancelButtonColor: '#425261',

                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                }).then((result) => {
                    if (result.isConfirmed) {
                        let payload = {
                            confirmationNumber: so.confirmationNumber
                        };

                        so.cancelBooking(payload);


                    }
                })
            },

            printWindow: function () {
                window.print();
            },
            resendConfirmation: function () {
                this.sendEmail = !this.sendEmail;

            }

            ,
            formatStayDate(input) {
                return moment(input).format("Do MMMM YYYY");
            },
            formatCancelTime(input) {

                let cancellationTime = moment(input).format('ha');
                let cancellationDate = moment(input).format('Do MMMM');

                return cancellationDate + ' at ' + cancellationTime;
            },
            canCancel(room) {
                if (this.hasVoucher) {
                    return false;
                }
                return moment(room.CancellationDateTime) > moment();
            },
            canCancelAll() {
                var result = true;

                if (this.booking.items.length > 1) {
                    for (let bi = 0; bi < this.booking.items.length; bi++) {

                        let booking = this.booking.items[bi];

                        if (booking.IsCancelled) {
                            return false;
                        }
                        let canCancel = this.canCancel(booking);
                        if (!canCancel) {
                            return false;
                        }
                    }
                }
                else {
                    result = false;
                }

                return result;
            },

            canAmend(input) {
                if (this.hasVoucher) {
                    return false;
                }
                return this.canCancel(input);
            },
            canAmendAll() {
                return this.canCancelAll();
            },
            formatGuests(guestCount) {
                let result = "";
           
                if (guestCount.Adults == 1) {
                    result += "1 adult"
                }
                if (guestCount.Adults > 1) {
                    result += guestCount.Adults + ' adults';
                }



                if (guestCount.Adults > 0 && guestCount.Children > 0 && guestCount.Infants == 0) {
                    result += " & ";
                }
                else if (guestCount.Adults > 0 && guestCount.Children > 0 && guestCount.Infants > 0) {
                    result += " , ";
                }


                if (guestCount.Children > 0) {

                    if (guestCount.Children == 1) {
                        result += "1 child";
                    }
                    if (guestCount.Children > 1) {
                        result += guestCount.Children + ' children';
                    }

                }


                if (guestCount.Infants > 0) {
                    result += " & ";
                    if (guestCount.Infants == 1) {
                        result += "1 infant";
                    }
                    if (guestCount.Infants > 1) {
                        result += guestCount.Infants + ' infants';
                    }

                }


                return result;
            },
            getRateType(rateCode) {

                if (this.configuration != null) {


                    let rateType = this.configuration.RateTypes.find(item => item.PMSCode == rateCode);
                    if (rateType != null) {
                        return rateType.DisplayName;
                    }
                }


                return rateCode;


            },

        }
    }
</script>
<style>
    .account-content .modal-container {
        height: 80vh !important
    }

    .account-content .modal-content {
        height: 100% !important;
    }

    .account-content .modal-body {
        overflow-y: auto !important;
        overflow-x: hidden;
        height: 90% !important;
    }
</style>
<style scoped>


    ul.guest-names {
        list-style: none;
    }

    .return-to-bookings {
        display: inline-block;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 15px;
        font-family: Montserrat;
        background-image: url(/Assets/img/booking/back-tab-arrow.svg);
        background-repeat: no-repeat;
        padding-left: 20px;
        background-position: left center;
        background-size: 6px 12px;
    }

    .amend-cancel-block {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

        .amend-cancel-block .btn {
            align-self: flex-start;
        }

    .lnk-print, .lnk-email{ font-weight: bold;}
</style>
